export const defaultPaginationOptions = [10, 25, 50, 100];

// generate pagination options number array, overriding the defaults.
// But the approach is invalid, because dataLength is itself limited by the page size.
// @return sorted array of values
export const generatePaginationOptions = (dataLength) => {
    let validOptions = [...defaultPaginationOptions];
    // append data length and sort array
    if (dataLength <= 100) {
        if (!validOptions.includes(dataLength)) {
            validOptions.push(dataLength);
            validOptions = validOptions
                .filter((num) => num <= dataLength) // remove values larger than dataLength
                .sort((a, b) => a - b);
            return [...new Set(validOptions)];
        }
    }
    return validOptions;
};

// check if cell being clicked is relevant to field specified
export const evaluateCellClick = (event, field) => {
    return event.currentTarget.dataset.field === field;
};
